<ptl-search
  [value]="searchText()"
  [placeholder]="placeholder()"
  [disabled]="disabled()"
  (valueChange)="onSearch($event)"
  (focusin)="onFocusSearch()"
></ptl-search>

@if (open() && !disabled()) {
  <div class="member-search__results" role="listbox">
    @if (loading()) {
      <p class="member-search__state">{{ 'translations.global.label.loading' | transloco }}</p>
    } @else if (visibleResults().length === 0 && searched()) {
      <p class="member-search__state">{{ 'translations.v3Forms.booking.noMembersFound' | transloco }}</p>
    } @else {
      @for (member of visibleResults(); track member.userId) {
        <button type="button" class="member-search__option" role="option" (click)="onPick(member)">
          <img class="member-search__avatar" [src]="member.imageUrl || 'assets/profile_image.png'" alt="" />
          <span class="member-search__text">
            <span class="member-search__name">{{ member.firstName }} {{ member.lastName }}</span>
            <span class="member-search__email">{{ member.email }}</span>
          </span>
        </button>
      }
    }
  </div>
}
